"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeedPriority = exports.Providers = exports.ModelTypes = void 0;
var ModelTypes;
(function (ModelTypes) {
    // Meta
    ModelTypes["llama_3_8b_instruct"] = "llama_3_8b_instruct";
    ModelTypes["llama_3_70b_instruct"] = "llama_3_70b_instruct";
    ModelTypes["llama_3_1_405b"] = "llama_3_1_405b";
    ModelTypes["llama_3_1_70b"] = "llama_3_1_70b";
    ModelTypes["llama_3_1_8b"] = "llama_3_1_8b";
    // Anthropic
    ModelTypes["claude_3_5_sonnet"] = "claude_3_5_sonnet";
    ModelTypes["claude_3_haiku"] = "claude_3_haiku";
    // Mistral
    ModelTypes["mistral_7b_instruct"] = "mistral_7b_instruct";
    ModelTypes["mixtral_8x7b_instruct"] = "mixtral_8x7b_instruct";
    // OpenAI Related
    ModelTypes["gpt_4"] = "gpt_4";
    ModelTypes["gpt_3_5_turbo"] = "gpt_3_5_turbo";
    ModelTypes["gpt_4o"] = "gpt_4o";
    ModelTypes["gpt_4_turbo"] = "gpt_4_turbo";
    ModelTypes["gpt_3_5_turbo_0125"] = "gpt_3_5_turbo_0125";
    ModelTypes["gpt_4o_mini"] = "gpt_4o_mini";
})(ModelTypes || (exports.ModelTypes = ModelTypes = {}));
var Providers;
(function (Providers) {
    Providers["openai"] = "openai";
    Providers["togetherai"] = "togetherai";
    Providers["groq"] = "groq";
    Providers["anthropic"] = "anthropic";
    Providers["bedrock"] = "bedrock";
})(Providers || (exports.Providers = Providers = {}));
var SpeedPriority;
(function (SpeedPriority) {
    SpeedPriority["low"] = "low";
    SpeedPriority["high"] = "high";
})(SpeedPriority || (exports.SpeedPriority = SpeedPriority = {}));
